export const urls = {
  preload: '/moneris/preload',
};

const queryKeyBase = ['moneris'];

export const queryKeys = {
  preload: ({
    amount,
    storeId,
  }: {
    amount: string;
    storeId: string | number;
  }) => [...queryKeyBase, 'preload', amount, storeId],
};
